<template>
  <section-layout
    :disabled="!cambiado || loading"
    :loading="loading || saving"
    :showButton="false"
  >
    <template v-slot:title>
      {{ localization.tabsTitles.general }}
    </template>
    <template v-slot:content>
      <v-row justify="start" align="center" dense>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.envioEmailAutomatico"
            id="envioEmailAutomatico"
            :label="localization.general.envioEmail"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col v-if="configuracion.envioEmailAutomatico" cols="12">
          <v-select
            v-model="getTranslatesTiposVisitaEmailAutomatico"
            id="getTranslatesTiposVisitaEmailAutomatico"
            :items="getTranslatesTiposVisita"
            :label="localization.general.envioEmailAutomatico"
            multiple
            chips
            deletable-chips
            clearable
            :hint="localization.general.envioEmailAutomaticoDetails"
            persistent-hint
            color="primary"
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12" v-if="idubapi.motor !== 'SIN_BD'">
          <v-checkbox
            v-model="configuracion.PV_DIRECCION_DATOS_IDENTIFICACION"
            id="PV_DIRECCION_DATOS_IDENTIFICACION"
            :label="localization.general.PV_DIRECCION_DATOS_IDENTIFICACION"
            color="primary"
            hide-details
            :disabled="saving"
            class="mt-0"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI"
            id="PV_PERMITIR_BORRAR_MAESTROS_CON_INCI"
            :label="localization.general.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.permitirIncidenciasRechazado"
            id="permitirIncidenciasRechazado"
            :label="localization.general.permitirAltaRechazadas"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.transitoLibreEstados"
            id="transitoLibreEstados"
            :label="localization.general.transitoLibre"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.permitirEnvioMasivo"
            id="permitirEnvioMasivo"
            :label="localization.general.envioPartes"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.mostrarObservacionesParteMono"
            id="mostrarObservacionesParteMono"
            :label="localization.general.mostrarObservacionesParteMono"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.asignarProveedorAuto"
            id="asignarProveedorAuto"
            :label="localization.general.asignarProveedorAuto"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.descargaImagenesPrimeraIncidencia"
            id="descargaImagenesPrimeraIncidencia"
            :label="localization.general.descargaImagenesPrimeraIncidencia"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_APP_ENVIO_RESUMEN_SUPERVISOR"
            id="PV_APP_ENVIO_RESUMEN_SUPERVISOR"
            :label="localization.general.PV_APP_ENVIO_RESUMEN_SUPERVISOR"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_WEB_ENVIO_RESUMEN_SUPERVISOR"
            id="PV_WEB_ENVIO_RESUMEN_SUPERVISOR"
            :label="localization.general.PV_WEB_ENVIO_RESUMEN_SUPERVISOR"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_MAIL_DESCRIPCION"
            id="PV_MAIL_DESCRIPCION"
            :label="localization.portal.PV_MAIL_DESCRIPCION"
            color="primary"
            hide-details
            :disabled="saving || !tienePDCoRolCliente()"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_MAIL_DATOS_CLIENTE"
            id="PV_MAIL_DATOS_CLIENTE"
            :label="localization.portal.PV_MAIL_DATOS_CLIENTE"
            color="primary"
            hide-details
            :disabled="saving || !tienePDCoRolCliente()"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_INFORME_NOTAS"
            id="PV_INFORME_NOTAS"
            :label="localization.general.PV_INFORME_NOTAS"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_INFORME_OBSERVACIONES"
            id="PV_INFORME_OBSERVACIONES"
            :label="localization.general.PV_INFORME_OBSERVACIONES"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>


        <!-- 294972 -->

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_VISITA_FECHA_ALTA_CLIENTE"
            id="PV_VISITA_FECHA_ALTA_CLIENTE"
            :label="
              localization.general.PV_VISITA_FECHA_ALTA_CLIENTE
            "
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_VISITA_REGISTRO_ENTRADA"
            id="PV_VISITA_REGISTRO_ENTRADA"
            :label="
              localization.general.PV_VISITA_REGISTRO_ENTRADA
            "
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>



        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_RESTRINGIR_NOTAS_A_PROVEEDORES"
            id="PV_RESTRINGIR_NOTAS_A_PROVEEDORES"
            :label="localization.general.PV_RESTRINGIR_NOTAS_A_PROVEEDORES"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox v-if="idubapi.rolProveedorWeb"
            v-model="configuracion.permitirAsignarPromocionesProveedor"
            id="permitirAsignarPromocionesProveedor"
            :label="localization.general.permitirAsignarPromocionesProveedor"
            color="primary"
            hide-details
            :disabled="saving"
            @change="mostrarAvisoDeseleccionarCheckPromocionesProveedor($event)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.proveedorVisitador"
            id="proveedorVisitador"
            :label="localization.general.proveedorVisitador"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.visualizarFiltroEvaluado"
            id="visualizarFiltroEvaluado"
            :label="localization.general.visualizarFiltroEvaluado"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.obligatorioAdjuntarImgAltaSolicitud"
            id="obligatorioAdjuntarImgAltaSolicitud"
            :label="localization.general.obligatorioAdjuntarImgAltaSolicitud"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.generarParteAlta"
            id="generarParteAlta"
            :label="localization.general.generarParteAlta"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_ALTA_ACTOR_PROVEEDOR"
            id="PV_ALTA_ACTOR_PROVEEDOR"
            :label="localization.general.PV_ALTA_ACTOR_PROVEEDOR"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_PERMISOS_EXTRA_PROVEEDOR"
            id="permisosExtraProveedor"
            :label="localization.general.PV_PERMISOS_EXTRA_PROVEEDOR"
            color="primary"
            hide-details
            :disabled="saving"
            @change="deshabilitarOpcionesExtraProveedor($event); updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_TRANSITO_ESTADOS_PROVEEDOR"
            id="permisosExtraProveedor"
            :label="localization.general.PV_TRANSITO_ESTADOS_PROVEEDOR"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.PV_IMPORTACION_CERRADAS"
            id="PV_IMPORTACION_CERRADAS"
            :label="
              localization.general.PV_IMPORTACION_CERRADAS
            "
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12" class="pb-0 pt-3">
          <v-text-field
            v-model="configuracion.descripcionTextoConformidad"
            id="descripcionTextoConformidad"
            :label="localization.general.descripcionTextoConformidad"
            color="primary"
            :disabled="saving"
            :rules="[rules.max(40)]"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="configuracion.obligatorioIncorporarDatosClienteCierre"
            id="obligatorioIncorporarDatosClienteCierre"
            :label="
              localization.general.obligatorioIncorporarDatosClienteCierre
            "
            color="primary"
            hide-details
            :disabled="saving || !configuracion.proveedorVisitador"
            class="mt-0"
            @change="updateCambiado(true)"
          />
        </v-col>


        <v-col cols="12" class="pb-0 pt-3">
          <v-text-field
            v-model="configuracion.PV_TEXTO_PIE_RESUMEN"
            id="PV_TEXTO_PIE_RESUMEN"
            :label="localization.general.PV_TEXTO_PIE_RESUMEN"
            color="primary"
            :disabled="saving"
            :rules="[rules.max(200)]"
            @change="updateCambiado(true)"
          />
        </v-col>
        
        <v-col cols="12">
          <v-text-field
            v-model="configuracion.diasRegistroCierre"
            id="diasRegistroCierre"
            :label="localization.general.diasRegistroCierre"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="configuracion.maxIncidenciasFicha"
            id="maxIncidenciasFicha"
            :label="localization.general.maxIncidenciasPDF"
            color="primary"
            hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="configuracion.PV_LIMITE_SOLICITUDES"
            id="PV_LIMITE_SOLICITUDES"
            :label="localization.general.PV_LIMITE_SOLICITUDES"
            color="primary"
            hide-details
            :disabled="saving"
            :rules="[rules.required, rules.mayor100, rules.menor20000]"
            @change="updateCambiado(true)"
          />
        </v-col>

        <v-col cols="12">
          <v-select
            v-model="configuracion.tiposIncidenciaVenta"
            id="tiposIncidenciaVenta"
            :items="tiposVisitaIncidencia"
            :label="localization.general.permitirVenta"
            :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
            item-value="code"
            multiple
            chips
            deletable-chips
            clearable
            hide-details
            color="primary"
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="configuracion.tiposIncidenciaAlquiler"
            id="tiposIncidenciaAlquiler"
            :items="tiposVisitaIncidencia"
            :label="localization.general.permitirAlquiler"
            :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
            item-value="code"
            multiple
            chips
            deletable-chips
            clearable
            hide-details
            color="primary"
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="configuracion.tiposIncidenciaSinOperacion"
            id="tiposIncidenciaSinOperacion"
            :items="tiposVisitaIncidencia"
            :label="localization.general.permitirSinOperacion"
            :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
            item-value="code"
            multiple
            chips
            deletable-chips
            clearable
            hide-details
            color="primary"
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>
      <ConfirmDialog 
        :text="localization.general.avisoDeseleccionarCheckPromocionesProveedor"
        @close="deletePromotionsProveedor()" 
        @cancel="dialogAsignarPromocionesProveedor = false; configuracion.permitirAsignarPromocionesProveedor = true"
        :dialogFlag="dialogAsignarPromocionesProveedor" 
        :textoBoton="textoAceptar" 
        textoTitulo="" />
    </template>
  </section-layout>
</template>

<script>
import { mapGetters } from "vuex";
import rulesMixin from "@/components/generic/rules.js";
import ConfirmDialog from '../custom/confirmDialog'

export default {
  mixins: [rulesMixin],
  components: {
    ConfirmDialog
  },
  data () {
    return {
      dialogAsignarPromocionesProveedor: false,
      textoAceptar: this.$t('verIncidencia').dialogConfirmacion.boton,
    }
  },
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cambiado: {
      type: Boolean,
      default: false,
    },
    configuracion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi',
      tiposVisitaIncidencia: "incidencias/getTiposVisita"
    }),
    localization() {
      return this.$t("sectionConfiguracion");
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    getTranslatesTiposVisita() {
      var translatesTiposVisitas = []
      const usuario = JSON.parse(localStorage.getItem('usuario'))
      
      if ( usuario.idioma !== 'spa' )
      {
        if ( usuario.idioma === 'eng' ) {
          translatesTiposVisitas.push('Pre-Sale')
          translatesTiposVisitas.push('After-market')
          translatesTiposVisitas.push('Pre-Delivery')
        }
        if ( usuario.idioma === 'eus' ) {
          translatesTiposVisitas.push('Aurresalmenta')
          translatesTiposVisitas.push('Ondorengo merkatua')
          translatesTiposVisitas.push('Entregatu aurretik')
        }
      }
      else {
        return this.configuracion.tiposVisita
      }
      return translatesTiposVisitas
    },
    getTranslatesTiposVisitaEmailAutomatico() {
      var translatesTiposVisitasEmailAutomatico = []
      const usuario = JSON.parse(localStorage.getItem('usuario'))
      
      if ( usuario.idioma !== 'spa' )
      {
        if ( usuario.idioma === 'eng' ) {
          translatesTiposVisitasEmailAutomatico.push('Pre-Sale')
          translatesTiposVisitasEmailAutomatico.push('After-market')
          translatesTiposVisitasEmailAutomatico.push('Pre-Delivery')
        }
        if ( usuario.idioma === 'eus' ) {
          translatesTiposVisitasEmailAutomatico.push('Aurresalmenta')
          translatesTiposVisitasEmailAutomatico.push('Ondorengo merkatua')
          translatesTiposVisitasEmailAutomatico.push('Entregatu aurretik')
        }
      }
      else {
        return this.configuracion.tiposVisitaEmailAutomatico
      }
      return translatesTiposVisitasEmailAutomatico
    }
  },
  methods: {
    updateCambiado(val) {
      this.$emit("cambiado", val);
    },
    deshabilitarOpcionesExtraProveedor(value) {
      if ( !value ) {
        // this.configuracion.PV_TRANSITO_ESTADOS_PROVEEDOR = false;
      }
    },
    mostrarAvisoDeseleccionarCheckPromocionesProveedor(value) {
      this.dialogAsignarPromocionesProveedor = false
      if ( value === false) {
        this.dialogAsignarPromocionesProveedor = true
      } else {
        this.configuracion.deletePromotionsProveedor = false
        this.updateCambiado(true)
      }
    },
    deletePromotionsProveedor() {
      this.dialogAsignarPromocionesProveedor = false
      this.configuracion.deletePromotionsProveedor = true
      this.updateCambiado(true)
    },
    tienePDCoRolCliente () {
      const tienePDC = this.configuracion.clienteCrearIncidencias === true && this.configuracion.clientesVer === true
      const tieneRolCliente = this.configuracion.clienteCrearIncidenciasWeb === true && this.configuracion.clientesVerWeb === true
      return (tienePDC || tieneRolCliente)
    }
  },
  watch: {
    "configuracion.proveedorVisitador"() {
      if (!this.configuracion.proveedorVisitador) {
        this.configuracion.obligatorioIncorporarDatosClienteCierre = false;
      }
    },
  },
};
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>
